import React, { useState } from 'react'
import TopBar from '../../components/admin/TopBar'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

const ChangePasswordPage = () => {
    const { id } = useParams();
    const API_URL = process.env.REACT_APP_API_URL;

    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const toggleNewPasswordVisibility = () => {
        setShowNewPassword(prevState => !prevState);
    }

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(prevState => !prevState);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const formData = {
            old_password: e.target.old_password.value,
            new_password: e.target.new_password.value,
            confirm_password: e.target.confirm_password.value
        };
    
        try {
            const token = localStorage.getItem('token');
    
            const response = await axios.put(
                `${API_URL}/change_password/${id}`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: response.data.message || 'Password changed successfully',
                showConfirmButton: false,
                timer: 2500
            });
            
            // Reset form
            e.target.reset();
            
        } catch (error) {
            console.error('Error:', error);
            
            let errorMessage = 'An error occurred while changing password';
            
            if (error.response) {
                errorMessage = error.response.data.error || errorMessage;
            } else if (error.request) {
                errorMessage = 'No response from server. Please check your connection.';
            }
            
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        }
    };

    return (
        <>
            <TopBar />
            <div className="p-2 mt-16">
                <div className="flex flex-col w-full">
                    <div className="flex pb-2 border-b-2">
                        <div className="font-semibold text-xl">
                            <label htmlFor="">Change password</label>
                        </div>
                    </div>
                    <div className="flex flex-col gap-2 mt-10 px-5 justify-center items-center w-full">
                        <p className="mb-0 mr-4 font-medium text-lg py-5">Change Password</p>
                        <form onSubmit={handleSubmit}>                            
                            <div className="flex flex-col w-full">
                                <div className="mb-6 md:w-96 w-full">
                                    <input 
                                        type="password"
                                        name="old_password"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 w-full p-2.5" 
                                        placeholder="Current Password"
                                        id="old_password"
                                        required
                                    />
                                </div>
                                <div className="relative mb-6 md:w-96 w-full">
                                    <input
                                        type={showNewPassword ? "text" : "password"}
                                        name="new_password"
                                        placeholder="New Password"
                                        id="new_password"
                                        className="block w-full py-3 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-green-500 focus:border-green-500"
                                        required
                                    />
                                    <button type="button"
                                        className="absolute right-3 bottom-2.5"
                                        onClick={toggleNewPasswordVisibility}
                                    >
                                        <i className={`fa-solid ${showNewPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                                    </button>
                                </div>
                                <div className="relative mb-6 md:w-96 w-full">
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        name="confirm_password"
                                        placeholder="Confirm Password"
                                        id="confirm_password"
                                        className="block w-full py-3 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-green-500 focus:border-green-500"
                                        required
                                    />
                                    <button type="button"
                                        className="absolute right-3 bottom-2.5"
                                        onClick={toggleConfirmPasswordVisibility}
                                    >
                                        <i className={`fa-solid ${showConfirmPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                                    </button>
                                </div>
                                <button type="submit" className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm md:w-96 w-full px-5 py-2.5 text-center">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChangePasswordPage